module.exports = __webpack_public_path__ + "img/12.f0315a44.svg";